import PropTypes from "prop-types";
import Add from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import { Cancel, Close, ConstructionRounded, PhotoCamera, TramOutlined } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Card,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Switch,
} from "@mui/material";
import ApnaSelect2 from "components/ApnaSelect";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import SkModal from "components/SkModal";
import React, { useEffect } from "react";
import { useRef } from "react";
import SkInput from "components/SkInput";
import { useState } from "react";
import ImagePicker from "components/ApnaUploader";
import { useDispatch, useSelector } from "react-redux";
import { getCategory } from "redux/festures/categorySlice";
import { getBrands } from "redux/festures/brandSlice";
import { getAttribute } from "redux/festures/AttributeSlice";
import ApnaSelect from "components/ApnaSelect/ApnaSelect";
import SkAutocomplete from "components/ApnaSelect/SkAutocomplete";
import MultiValueInput from "components/SkInputs";
import { createProducts } from "redux/festures/productSlice";
import FileUploader from "components/ApnaUploader/pdfUploader";
import AttributeInput from "components/ApnaSelect/Attribute";
import { handleAlert } from "redux/festures/alertSlice";
// import http from "Utils/api";
import { useMaterialUIController } from "context";
import { updateProduct } from "redux/festures/productSlice";
import http from "Utils/api2";
import { updateProductPic } from "redux/festures/productSlice";
import { getSingleProduct } from "redux/festures/productSlice";
import SkLoading from "components/SkLoading";
import { getAllGlobalProducts } from "redux/festures/productSlice";
import { EditorState, convertToRaw, convertFromHTML } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import Skeditor from "components/SKeditor";
import { getAllCity } from "redux/festures/citySlice";
import SkDatePicker from "components/SkDataPicker";
import MultiInput from "components/MultiInput";
import { getSubGlobalCategory } from "redux/festures/categorySlice";
import CircularProgress from "@mui/material/CircularProgress";
import AstrieskIcon from "components/AstrieskIcon";
import InfiniteApnaSelect from "components/ApnaSelect/InfiniteApnaSelect";

const CreateForm = ({
  isOpen,
  setIsOpen,
  isSwitch,
  setIsSwitch,
  productId,
  updateProductModal,
  setUpdateProductModal,
  ecom,
}) => {
  const picInput = useRef(null);
  const dispatch = useDispatch();
  const admin = localStorage.getItem("admin_id");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { AllProducts, singleProduct, Loading, createUpdateLoading } = useSelector((state) => ({
    ...state.isProducts,
  }));

  const { city } = useSelector((state) => state.isCity);
  const { category, subCategory } = useSelector((state) => ({ ...state.isCategory }));

  ;

  const [isThumbnil, setIsThumbnil] = useState("");
  const [serverThumbnail, setServerThumbnail] = useState("");
  const [isImages, setIsImages] = useState(null);
  const [serverImages, setServerImages] = useState(null);
  const [additionalImages, setAdditionalImages] = useState(null);
  const [serverAdditionalImages, setServerAdditionalImages] = useState(null);
  // const [additionalVideos, setAdditionalVideos] = useState(null)
  // const [serverAdditionalVideos, setServerAdditionalVideos] = useState(null)
  // const [isVideo, setIsVideo] = useState(null);
  // const [serverVideo, setServerVideo] = useState(null)
  const [allBrands, setAllBrands] = useState([]);
  const [allTax, setAllTax] = useState([]);
  const [isProductDescriptionServer, setIsProductDescriptionServer] = useState("");
  const [isProductDescription, setIsProductDescription] = useState(EditorState.createEmpty());


  const [editData, setEditData] = useState(null);
  const [variant, setVariant] = useState({
    size: "",
    mrp: "",
    discount: "",
    stock: "",
  });

  const [variantsList, setVariantsList] = useState([
    { size: "", mrp: "", discount: "", stock: "" }
  ]);

  const [hasColorPalette, setHasColorPalette] = useState(false);
  const [allowCustomColorCode, setAllowCustomColorCode] = useState(true);
  const [colorsList, setColorsList] = useState([]);

  // Helper function to ensure specifications are properly initialized
  const initializeSpecifications = (specs) => {
    if (!specs) return [];
    if (Array.isArray(specs)) {
      return specs.map(spec => {
        if (typeof spec === 'string') {
          const parts = spec.split(/:(.+)/);
          return { key: parts[0]?.trim() || "", value: parts[1]?.trim() || "" };
        }
        return {
          key: spec?.key || "",
          value: spec?.value || ""
        };
      });
    }
    if (typeof specs === 'string') {
      const pairs = specs.split(/\s{2,}|\n/).map(s => s.trim()).filter(Boolean);
      return pairs.map(pair => {
        const parts = pair.split(/:(.+)/);
        return { key: parts[0]?.trim() || "", value: parts[1]?.trim() || "" };
      });
    }
    return [];
  };

  const [isData, setIsData] = useState({
    title: "",
    price: "",
    include: [""],
    exclude: [""],
    features: [""],
    highlights: [""],
    warranty: "",
    returnInDays: "",
    sku: "",
    categoryId: "",
    pcategoryId: "",
    mrp: "",
    time: "",
    // // cityId: "",
    taxId: "",
    subtitle: "",
    metaTitle: "",
    metaDescription: "",
    metaKeywords: [],
    specifications: [],
  });

  const types = {
    service: {
      title: "",
      price: "",
      include: [""],
      exclude: [""],
      warranty: "",
      categoryId: "",
      pcategoryId: "",
      mrp: "",
      time: "1",
      // cityId: "",
      taxId: "",
      subtitle: "",
      metaTitle: "",
      metaDescription: "",
      metaKeywords: [""],
      specifications: [],
    },
    serviceServer: {
      title: singleProduct?.title || "",
      price: singleProduct?.price || "",
      include: singleProduct?.include || [""],
      exclude: singleProduct?.exclude || [""],
      metaTitle: singleProduct?.meta?.title || "",
      metaDescription: singleProduct?.meta?.description || "",
      metaKeywords: singleProduct?.meta?.keywords || [""],
      warranty: typeof singleProduct?.warranty === typeof "" ? 1 : singleProduct?.warranty,

      categoryId: singleProduct?.categoryId?._id || "",
      pcategoryId: singleProduct?.categoryId?.pCategory || "",
      mrp: singleProduct?.mrp || "",
      time: singleProduct?.time || "1",
      // cityId: singleProduct?.// cityId?._id || "",
      taxId: singleProduct?.taxId?._id || "",
      subtitle: singleProduct?.subtitle || "",
      specifications: initializeSpecifications(singleProduct?.specifications),
    },

    ecomm: {
      title: "",
      price: "",
      features: [""],
      highlights: [""],
      warranty: "",
      returnInDays: "",
      sku: "",
      categoryId: "",
      pcategoryId: "",
      mrp: "",
      time: "",
      // cityId: "",
      taxId: "",
      subtitle: "",
      stock: "",
      brandId: "",
      metaTitle: "",
      metaDescription: "",
      metaKeywords: [""],
      specifications: [],
    },
    ecommServer: {
      title: singleProduct?.title || "",
      price: singleProduct?.price || "",
      features: singleProduct?.features && singleProduct?.features?.length ? singleProduct.features : [""],
      highlights: singleProduct?.highlights && singleProduct?.highlights?.length ? singleProduct.highlights : [""],
      metaTitle: singleProduct?.meta?.title || "",
      metaDescription: singleProduct?.meta?.description || "",
      metaKeywords: singleProduct?.meta?.keywords || [""],
      warranty: typeof singleProduct?.warranty === typeof "" ? 1 : (singleProduct?.warranty ?? ""),
      returnInDays: singleProduct?.returnInDays ?? "",
      sku: singleProduct?.sku || "",
      categoryId: singleProduct?.categoryId?._id || "",
      pcategoryId: singleProduct?.categoryId?.pCategory || "",
      mrp: singleProduct?.mrp || "",
      time: singleProduct?.time || "",
      // cityId: singleProduct?.// cityId?._id || "",
      taxId: singleProduct?.taxId?._id || "",
      subtitle: singleProduct?.subtitle || "",
      stock: singleProduct?.stock || "",
      brandId: singleProduct?.brandId?._id || "",
      specifications: initializeSpecifications(singleProduct?.specifications),
    },
  };
  useEffect(() => {
    if (isOpen && singleProduct) {
      // Common fields
      const baseData = {
        title: singleProduct.title || "",
        subtitle: singleProduct.subtitle || "",
        time: singleProduct.time || (ecom ? "" : "1"),
        warranty: typeof singleProduct.warranty === "string" ? 1 : (singleProduct.warranty ?? ""),
        taxId:
          (typeof singleProduct.taxId === "object"
            ? singleProduct.taxId?._id
            : singleProduct.taxId) || "",
        metaTitle: singleProduct.meta?.title || "",
        metaDescription: singleProduct.meta?.description || "",
        metaKeywords: singleProduct.meta?.keywords || [""],
        specifications: initializeSpecifications(singleProduct.specifications),
        categoryId:
          (typeof singleProduct.categoryId === "object"
            ? singleProduct.categoryId?._id
            : singleProduct.categoryId) ||
          (typeof singleProduct.category === "object"
            ? singleProduct.category?._id
            : singleProduct.category) ||
          (typeof singleProduct.subCategoryId === "object"
            ? singleProduct.subCategoryId?._id
            : singleProduct.subCategoryId) ||
          "",
        pcategoryId: singleProduct.categoryId?.pCategory || "",
      };

      if (ecom) {
        setIsData({
          ...baseData,
          price: singleProduct.price || (singleProduct.variants?.[0]?.price ?? ""),
          mrp: singleProduct.mrp || (singleProduct.variants?.[0]?.mrp ?? ""),
          stock: singleProduct.stock || (singleProduct.variants?.[0]?.stock ?? ""),
          brandId: singleProduct.brandId?._id || singleProduct.brandId || "",
          features: singleProduct.features && singleProduct.features.length > 0 ? singleProduct.features : [""],
          highlights: singleProduct.highlights && singleProduct.highlights.length > 0 ? singleProduct.highlights : [""],
          returnInDays: singleProduct.returnInDays ?? "",
          sku: singleProduct.sku || "",
        });

        if (singleProduct.variants?.length > 0) {
          setVariantsList(
            singleProduct.variants.map((v) => ({
              size: v.size || "",
              mrp: v.mrp || "",
              discount: v.discount || "",
              stock: v.stock || "",
            }))
          );
        }

        if (singleProduct.colors && singleProduct.colors.length > 0) {
          setHasColorPalette(true);
          setColorsList(
            singleProduct.colors.map((c) => ({
              name: c.name || "",
              code: c.code || "",
              hex: c.hex || "#ffffff",
              family: c.family || "",
            }))
          );
          setAllowCustomColorCode(
            singleProduct.allowCustomColorCode !== undefined
              ? singleProduct.allowCustomColorCode
              : true
          );
        } else {
          setHasColorPalette(false);
          setColorsList([]);
          setAllowCustomColorCode(true);
        }
      } else {
        setIsData({
          ...baseData,
          price: singleProduct.price || "",
          mrp: singleProduct.mrp || "",
          include: singleProduct.include || [""],
          exclude: singleProduct.exclude || [""],
        });
      }

      setServerThumbnail(singleProduct?.thumnail || singleProduct?.thumbnail);
      const tempImages = [];
      const tempImages2 = [];

      if (singleProduct?.images && singleProduct?.images?.length)
        singleProduct?.images?.map((ele) =>
          ele?.type === "IMAGE" ? tempImages?.push(ele) : null
        );

      if (singleProduct?.additional && singleProduct?.additional?.length)
        singleProduct?.additional?.map((ele) =>
          ele?.type === "IMAGE" ? tempImages2?.push(ele) : null
        );

      setServerImages(tempImages && tempImages?.length ? tempImages : null);
      setServerAdditionalImages(tempImages2 && tempImages2?.length ? tempImages2 : null);
      setIsProductDescriptionServer(singleProduct?.description || "");
    } else {
      // Reset for CREATE mode
      const emptyData = ecom ? types?.ecomm : types?.service;
      setIsData(emptyData);
      setVariantsList([{ size: "", mrp: "", discount: "", stock: "" }]);
      setHasColorPalette(false);
      setColorsList([]);
      setAllowCustomColorCode(true);
      setServerImages(null);
      setServerAdditionalImages(null);
      setServerThumbnail(null);
      setIsImages(null);
      setAdditionalImages(null);
      setIsThumbnil("");
      setIsProductDescriptionServer("");
      setIsProductDescription(EditorState.createEmpty());
    }
  }, [singleProduct, isOpen, ecom]);




  useEffect(() => {
    if (isData?.pcategoryId)
      dispatch(
        getSubGlobalCategory(
          ecom
            ? `/eCommerce/getCategoryWithPcategory/${isData?.pcategoryId}/${admin}`
            : `/getCategoryWithPcategory/${isData?.pcategoryId}/${admin}`
        )
      );
  }, [isData?.pcategoryId]);

  // Fetch tax, city, etc. on form open
  useEffect(() => {
    if (isOpen) {
      if (!ecom) dispatch(getAllCity(`/getAllCityByAdmin/${admin}`));

      http
        .get(`/getAllTax/${admin}`)
        .then((response) => {
          const tax =
            response?.data?.data && response?.data?.data?.length
              ? [...response?.data?.data]?.map((ele) => {
                const temp = { ...ele };
                temp.taxPercent = `${temp.taxPercent} %`;
                return temp;
              })
              : [];
          setAllTax(tax);
        })
        .catch((error) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: "error",
              msg: error?.response?.data?.message,
            })
          );
        });
      if (!ecom) {
        dispatch(getCategory(`/getAllNullPcategory/${admin}`));
      }
    }
  }, [isOpen, ecom]);

  // Fetch brands when modal opens or categoryId changes (ecom only)
  useEffect(() => {
    if (isOpen && ecom) {
      if (isData?.categoryId) {
        http
          .get(`/getAllBrandByAdmin/${admin}/${isData?.categoryId}?limit=100`)
          .then((response) => {
            const brandsList = response?.data?.data || [];
            if (brandsList.length > 0) {
              setAllBrands(brandsList);
            } else {
              http
                .get(`/getAllBrands?limit=100`)
                .then((allRes) => {
                  setAllBrands(allRes?.data?.data || []);
                })
                .catch(() => setAllBrands([]));
            }
          })
          .catch(() => {
            http
              .get(`/getAllBrands?limit=100`)
              .then((allRes) => {
                setAllBrands(allRes?.data?.data || []);
              })
              .catch(() => setAllBrands([]));
          });
      } else {
        // Pre-load all brands even before category is selected so brand list is always available
        http
          .get(`/getAllBrands?limit=100`)
          .then((response) => {
            setAllBrands(response?.data?.data || []);
          })
          .catch(() => setAllBrands([]));
      }
    } else {
      setAllBrands([]);
    }
  }, [isOpen, ecom, isData?.categoryId]);

  const handleVariantChange = (index, e) => {
    const { name, value } = e.target;

    const updatedVariants = [...variantsList];
    updatedVariants[index][name] = value;

    setVariantsList(updatedVariants);
  };

  const handleAddVariant = () => {
    setVariantsList([
      ...variantsList,
      { size: "", mrp: "", discount: "", stock: "" }
    ]);
  };

  const handleDeleteVariant = (index) => {
    if (variantsList.length <= 1) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "warning",
          msg: "At least one variant is required",
        })
      );
      return;
    }
    const updated = variantsList.filter((_, i) => i !== index);
    setVariantsList(updated);
  };

  const handleAddColor = () => {
    setColorsList([
      ...colorsList,
      { name: "", code: "", hex: "#1a73e8", family: "" },
    ]);
  };

  const handleDeleteColor = (index) => {
    const updated = colorsList.filter((_, i) => i !== index);
    setColorsList(updated);
  };

  const handleColorChange = (index, field, value) => {
    const updated = [...colorsList];
    updated[index][field] = value;
    setColorsList(updated);
  };

  const handleLoadPresetColors = () => {
    setColorsList([
      { name: "Super White", code: "AP-0001", hex: "#FFFFFF", family: "Whites" },
      { name: "Morning Frost", code: "AP-0742", hex: "#F0F4F8", family: "Whites" },
      { name: "Classic Ivory", code: "AP-0315", hex: "#FFFFF0", family: "Yellows" },
      { name: "Royale Blue", code: "AP-8201", hex: "#1A5276", family: "Blues" },
      { name: "Sky Mist", code: "AP-9120", hex: "#85C1E9", family: "Blues" },
      { name: "Misty Sage", code: "AP-7431", hex: "#A3E4D7", family: "Greens" },
      { name: "Warm Terracotta", code: "AP-5104", hex: "#D35400", family: "Warm" },
      { name: "Charcoal Grey", code: "AP-8490", hex: "#2C3E50", family: "Greys" },
    ]);
  };

  const handleSwitchControll = (event, state, setState) => {
    setState(event.target.state);
  };

  ;
  const handleSubmitCrateProduct = (e) => {
    e.preventDefault();

    const isCreate = !singleProduct; // 👉 important flag

    const convertContentToHTML = () => {
      const contentState = isProductDescription?.getCurrentContent();
      return stateToHTML(contentState);
    };

    const buildFormData = () => {
      const formdata = new FormData();
      const isCreate = !singleProduct;

      // -------- IMAGES --------
      if (isImages?.length > 0) {
        isImages.forEach((img) => formdata.append("images", img));
      }

      if (additionalImages?.length > 0) {
        additionalImages.forEach((img) => formdata.append("additional", img));
      }

      if (isThumbnil) {
        formdata.append("thumnail", isThumbnil);
      }

      // -------- DATA FIELDS (CLEAN LOOP) --------
      const skipFields = [
        "price",
        "mrp",
        "stock",
        "thumnail",
        "images",
        "additional",
        "brandName",
        "sku",
        "features",
        "highlights",
        "include",
        "exclude",
        "metaKeywords",
        "metaTitle",
        "metaDescription",
        "specifications",
        "colors",
        "allowCustomColorCode",
      ];

      // Add base fields from isData
      Object.keys(isData || {}).forEach((ele) => {
        if (skipFields.includes(ele)) return;

        const val = isData[ele];
        if (val !== undefined && val !== null && val !== "") {
          formdata.append(ele, val);
        }
      });

      // -------- META DATA --------
      formdata.append("metaTitle", isData.metaTitle || "");
      formdata.append("metaDescription", isData.metaDescription || "");

      // -------- ARRAYS & SPECIALS --------
      if (isData.features?.length > 0) {
        isData.features.forEach((f) => f && formdata.append("features", f));
      }
      if (isData.highlights?.length > 0) {
        isData.highlights.forEach((h) => h && formdata.append("highlights", h));
      }
      if (isData.include?.length > 0) {
        isData.include.forEach((i) => i && formdata.append("include", i));
      }
      if (isData.exclude?.length > 0) {
        isData.exclude.forEach((e) => e && formdata.append("exclude", e));
      }
      if (isData.metaKeywords?.length > 0) {
        isData.metaKeywords.forEach((k, i) => k && formdata.append(`metaKeywords[${i}]`, k));
      }

      // -------- BRAND --------
      if (ecom) {
        if (isData?.brandName) {
          formdata.append("brandName", isData.brandName);
        } else if (isData?.brandId) {
          const brand = allBrands.find((b) => b._id === isData.brandId);
          formdata.append("brandName", brand ? brand.name : "Asian Paint");
        } else {
          formdata.append("brandName", "Asian Paint"); // Fallback for ecommerce
        }
      }

      // -------- VARIANTS & BASE PRICE --------
      if (ecom && variantsList.length > 0) {
        variantsList.forEach((v, index) => {
          formdata.append(`variants[${index}][size]`, v.size || "");
          formdata.append(`variants[${index}][mrp]`, v.mrp || 0);
          formdata.append(`variants[${index}][discount]`, v.discount || 0);
          formdata.append(`variants[${index}][stock]`, v.stock || 0);
        });

        // Top-level fields (required by some ecommerce models)
        formdata.append("mrp", variantsList[0].mrp || 0);
        formdata.append("price", variantsList[0].mrp || 0);
        formdata.append("stock", variantsList[0].stock || 0);
      } else {
        // Service products or fallback
        formdata.append("price", isData.price || 0);
        formdata.append("mrp", isData.mrp || 0);
        if (ecom) formdata.append("stock", isData.stock || 0);
      }

      // -------- SKU --------
      const finalSku = isData?.sku && isData.sku.trim() !== ""
        ? isData.sku.trim()
        : (!isCreate && singleProduct?.sku
          ? singleProduct.sku
          : ((isData?.title || "SKU").replace(/\s+/g, "-").toUpperCase() + "-" + Date.now()));
      formdata.append("sku", finalSku);

      // -------- SPECIFICATIONS --------
      if (isData.specifications?.length > 0) {
        isData.specifications.forEach((spec, index) => {
          if (spec && (spec.key || spec.value)) {
            formdata.append(`specifications[${index}][key]`, spec.key || "");
            formdata.append(`specifications[${index}][value]`, spec.value || "");
          }
        });
      }

      // -------- PAINT COLORS & SHADES --------
      if (ecom) {
        if (hasColorPalette && colorsList.length > 0) {
          const validColors = colorsList.filter(
            (c) => (c.name && c.name.trim()) || (c.code && c.code.trim())
          );
          formdata.append("colors", JSON.stringify(validColors));
          formdata.append("allowCustomColorCode", allowCustomColorCode ? "true" : "false");
        } else if (hasColorPalette) {
          formdata.append("colors", JSON.stringify([]));
          formdata.append("allowCustomColorCode", allowCustomColorCode ? "true" : "false");
        } else {
          formdata.append("colors", JSON.stringify([]));
          formdata.append("allowCustomColorCode", "false");
        }
      }

      // -------- DESCRIPTION --------
      formdata.append("description", convertContentToHTML());

      return formdata;
    };


    const formdata = buildFormData();

    if (singleProduct) {
      const url = ecom
        ? `${process.env.REACT_APP_APII}/eCommerce/updateProduct/${singleProduct._id}/${admin}`
        : `${process.env.REACT_APP_APII}/updateProduct/${singleProduct._id}/${admin}`;

      dispatch(updateProduct({ url, data: formdata }))
        .then((res) => {
          if (res?.payload?.success) {
            dispatch(
              handleAlert({
                isOpen: true,
                type: "success",
                msg: "Product updated successfully",
              })
            );
            setIsOpen(false); // close modal
          } else {
            dispatch(
              handleAlert({
                isOpen: true,
                type: "error",
                msg: res?.payload?.message || "Update failed",
              })
            );
          }
        });
    }
    else {
      const url = ecom
        ? `${process.env.REACT_APP_APII}/eCommerce/createProduct/${admin}`
        : `${process.env.REACT_APP_APII}/createProduct/${admin}`;

      dispatch(createProducts({ url, data: formdata }))
        .then((res) => {
          if (res?.payload?.success) {
            dispatch(
              handleAlert({
                isOpen: true,
                type: "success",
                msg: "Product created successfully",
              })
            );
            setIsOpen(false); // close modal
          } else {
            dispatch(
              handleAlert({
                isOpen: true,
                type: "error",
                msg: res?.payload?.message || "Creation failed",
              })
            );
          }
        });
    }

  };



  const handleForm = (e) => {
    const { name, value } = e.target;

    // Only allow numbers in these fields
    if (["price", "mrp", "stock", "warranty", "returnInDays"].includes(name)) {
      const numericVal = value === "" ? "" : value.replace(/[^0-9]/g, "");
      setIsData((prev) => ({
        ...prev,
        [name]: numericVal,
      }));
    } else if (!ecom && name === "time") {
      const numericVal = value === "" ? "" : value.replace(/[^0-9]/g, "");
      setIsData((prev) => ({
        ...prev,
        [name]: numericVal,
      }));
    } else if (name === "categoryId") {
      // Handle category change: reset brand when category changes
      setIsData((prev) => ({
        ...prev,
        [name]: value,
        brandId: "",
      }));
    } else {
      // All other fields
      setIsData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Price <= MRP validation
    if (
      (name === "price" || name === "mrp") &&
      value !== "" &&
      isData?.price &&
      isData?.mrp &&
      Number(isData.price) > Number(isData.mrp)
    ) {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "warning",
          msg: "Price should be less than or equal to MRP",
        })
      );

      setIsData((prev) => ({
        ...prev,
        price: prev.mrp,
      }));
    }
  };




  return (
    <>
      <SkModal
        show={isOpen}
        unShow={setIsOpen}
        width={{ sx: "100%", md: "70%", xl: "70%", sm: "100%" }}
        height={"90vh"}
        padding={3}
        overflowY={true}
      >
        <MDBox
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 2,
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Card
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 , 10px",
            }}
          >
            <MDTypography variant="h6" py={0.9}>
              {singleProduct
                ? !ecom
                  ? "Update Service"
                  : " Update Product"
                : !ecom
                  ? "Create Service"
                  : " Create Product"}
            </MDTypography>
          </Card>
          {Loading ? (
            <SkLoading />
          ) : (
            <MDBox
              display="flex"
              alignItems="center"
              lineHeight={1}
              sx={({ palette: { dark, white, info } }) => ({
                justifyContent: "center",
                textAlign: "center",
                flexDirection: "column",
                gap: 3,
                width: "100%",
                flexWrap: "wrap",
                border: 1,
                borderColor: darkMode ? white.main : dark.main,
                borderRadius: 3,
                py: 3,
              })}
              component="form"
              role="form"
              onSubmit={handleSubmitCrateProduct}
            >
              <MDBox
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service Title" : "Product Title"} <AstrieskIcon />
                </MDTypography>
                <MDInput
                  disabled={createUpdateLoading}
                  required={true}
                  type="text"
                  placeholder="Product Title"
                  fullWidth
                  name="title"
                  value={isData?.title}
                  onChange={handleForm}
                />
              </MDBox>
              <MDBox
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service Subtitle" : "Product Subtitle"} <AstrieskIcon />
                </MDTypography>
                <MDInput
                  disabled={createUpdateLoading}
                  required={true}
                  type="text"
                  placeholder="Product Subtitle"
                  fullWidth
                  name="subtitle"
                  value={isData?.subtitle}
                  onChange={handleForm}
                />
              </MDBox>

              {ecom ? (
                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"90%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    Product SKU <span style={{ fontSize: "12px", fontWeight: "normal" }}>(Optional - Auto-generated if left blank)</span>
                  </MDTypography>
                  <MDInput
                    disabled={createUpdateLoading}
                    type="text"
                    placeholder="e.g. Ck391MQ"
                    fullWidth
                    name="sku"
                    value={isData?.sku || ""}
                    onChange={handleForm}
                  />
                </MDBox>
              ) : null}

              <MDBox
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service Description" : "Product Description"} <AstrieskIcon />
                </MDTypography>
                {/* <MDInput
                  required={true}
                  type="text"
                  placeholder="Product Description"
                  fullWidth
                  name="description"
                  value={isData?.description}
                  onChange={handleForm}
                  multiline
                  rows={5}
                /> */}
                <Skeditor
                  required={true}
                  disabled={createUpdateLoading}
                  editorState={isProductDescription}
                  setEditorState={setIsProductDescription}
                  placeholder={!ecom ? "Service Description" : "Product Description"}
                  initialContent={isOpen && singleProduct ? isProductDescriptionServer : ""}
                  isButton={true}
                // content={"Blog Content"}
                />
              </MDBox>

              <MDBox
                display={"flex"}
                alignItems="center"
                justifyContent="space-between"
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                {ecom ? (
                  <MDBox width={"100%"}>
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      width={"100%"}
                      mb={1}
                    >
                      <MDTypography variant="h6">
                        Product Variants <AstrieskIcon />
                      </MDTypography>
                    </MDBox>

                    {variantsList.map((variant, index) => (
                      <MDBox
                        key={index}
                        mt={2}
                        p={2}
                        border="1px solid #ddd"
                        borderRadius="8px"
                        display="flex"
                        flexDirection="column"
                        gap={2}
                        width={"100%"}
                      >
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="subtitle2" fontWeight="bold">
                            Variant #{index + 1}
                          </MDTypography>
                          {variantsList.length > 1 && (
                            <MDButton
                              variant="text"
                              color="error"
                              size="small"
                              onClick={() => handleDeleteVariant(index)}
                            >
                              <Delete sx={{ mr: 0.5 }} /> Remove
                            </MDButton>
                          )}
                        </MDBox>

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                          <MDInput
                            label="Size (e.g. 1L, 4L, 10L, 12x24)"
                            name="size"
                            required
                            value={variant.size}
                            onChange={(e) => handleVariantChange(index, e)}
                            fullWidth
                          />
                          <MDInput
                            label="MRP (₹)"
                            name="mrp"
                            required
                            type="number"
                            value={variant.mrp}
                            onChange={(e) => handleVariantChange(index, e)}
                            fullWidth
                          />
                        </Stack>

                        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                          <MDInput
                            label="Discount (%)"
                            name="discount"
                            type="number"
                            value={variant.discount}
                            onChange={(e) => handleVariantChange(index, e)}
                            fullWidth
                          />
                          <MDInput
                            label="Stock"
                            name="stock"
                            required
                            type="number"
                            value={variant.stock}
                            onChange={(e) => handleVariantChange(index, e)}
                            fullWidth
                          />
                        </Stack>
                      </MDBox>
                    ))}

                    <MDButton
                      sx={{ mt: 2 }}
                      variant="outlined"
                      color="info"
                      onClick={handleAddVariant}
                    >
                      <Add sx={{ mr: 0.5 }} /> Add Another Variant
                    </MDButton>
                  </MDBox>
                ) : null}

                {/* -------- Paint Color Codes & Shade Palette (Ecommerce Only) -------- */}
                {ecom ? (
                  <MDBox
                    width={"100%"}
                    mt={3}
                    p={2.5}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "10px",
                      backgroundColor: darkMode ? "rgba(255,255,255,0.02)" : "#fafafa",
                    }}
                  >
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                    >
                      <MDBox textAlign="left">
                        <MDTypography variant="h6" fontWeight="bold">
                          Paint Color Codes & Shade Palette
                        </MDTypography>
                        <MDTypography variant="caption" color="text">
                          Enable for paints & coatings to offer pre-defined shade codes or custom shade card selection
                        </MDTypography>
                      </MDBox>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={hasColorPalette}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setHasColorPalette(checked);
                              if (checked && colorsList.length === 0) {
                                handleAddColor();
                              }
                            }}
                            color="info"
                          />
                        }
                        label={
                          <MDTypography variant="button" fontWeight="medium">
                            {hasColorPalette ? "Palette Active" : "Palette Disabled"}
                          </MDTypography>
                        }
                      />
                    </MDBox>

                    {hasColorPalette && (
                      <MDBox mt={2}>
                        <MDBox
                          p={1.5}
                          mb={2}
                          sx={{
                            backgroundColor: darkMode ? "rgba(255,255,255,0.05)" : "#f0f7ff",
                            borderRadius: "8px",
                            border: "1px solid #d0e2ff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "wrap",
                            gap: 1,
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={allowCustomColorCode}
                                onChange={(e) => setAllowCustomColorCode(e.target.checked)}
                                color="info"
                              />
                            }
                            label={
                              <MDTypography variant="button" fontWeight="medium">
                                Allow Customers to Enter Custom Shade Code (from physical Shade Card / Fandeck)
                              </MDTypography>
                            }
                          />

                          {colorsList.length === 0 && (
                            <MDButton
                              size="small"
                              variant="outlined"
                              color="info"
                              onClick={handleLoadPresetColors}
                            >
                              + Load 8 Standard Paint Shades
                            </MDButton>
                          )}
                        </MDBox>

                        {colorsList.map((color, index) => (
                          <MDBox
                            key={index}
                            mt={1.5}
                            p={2}
                            border="1px solid #ddd"
                            borderRadius="8px"
                            display="flex"
                            alignItems="center"
                            gap={2}
                            flexWrap="wrap"
                            width={"100%"}
                            sx={{
                              backgroundColor: darkMode ? "rgba(255,255,255,0.01)" : "#fff",
                            }}
                          >
                            <MDBox
                              display="flex"
                              alignItems="center"
                              gap={1}
                              title="Click to choose shade color"
                            >
                              <input
                                type="color"
                                value={color.hex || "#ffffff"}
                                onChange={(e) => handleColorChange(index, "hex", e.target.value)}
                                style={{
                                  width: 44,
                                  height: 44,
                                  borderRadius: "50%",
                                  border: "2px solid #ccc",
                                  cursor: "pointer",
                                  padding: 0,
                                  backgroundColor: "transparent",
                                }}
                              />
                              <MDTypography variant="caption" fontWeight="bold">
                                {color.hex}
                              </MDTypography>
                            </MDBox>

                            <MDBox sx={{ flex: 2, minWidth: "150px" }}>
                              <MDInput
                                label="Color / Shade Name (e.g. Royale Blue)"
                                value={color.name || ""}
                                onChange={(e) => handleColorChange(index, "name", e.target.value)}
                                fullWidth
                              />
                            </MDBox>

                            <MDBox sx={{ flex: 1.5, minWidth: "130px" }}>
                              <MDInput
                                label="Shade Code (e.g. AP-8201)"
                                value={color.code || ""}
                                onChange={(e) => handleColorChange(index, "code", e.target.value)}
                                fullWidth
                              />
                            </MDBox>

                            <MDBox sx={{ flex: 1.5, minWidth: "120px" }}>
                              <MDInput
                                label="Color Family (e.g. Blues)"
                                value={color.family || ""}
                                onChange={(e) => handleColorChange(index, "family", e.target.value)}
                                fullWidth
                              />
                            </MDBox>

                            <MDButton
                              variant="text"
                              color="error"
                              size="small"
                              onClick={() => handleDeleteColor(index)}
                            >
                              <Delete />
                            </MDButton>
                          </MDBox>
                        ))}

                        <MDBox display="flex" gap={2} mt={2}>
                          <MDButton
                            variant="outlined"
                            color="info"
                            size="small"
                            onClick={handleAddColor}
                          >
                            <Add sx={{ mr: 0.5 }} /> Add Shade / Color Code
                          </MDButton>

                          {colorsList.length > 0 && (
                            <MDButton
                              variant="text"
                              color="secondary"
                              size="small"
                              onClick={handleLoadPresetColors}
                            >
                              Reset with 8 Standard Shades
                            </MDButton>
                          )}
                        </MDBox>
                      </MDBox>
                    )}
                  </MDBox>
                ) : null}

                {ecom ? (
                  <MDBox
                    lineHeight={1}
                    gap={3}
                    width={"100%"}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <MDTypography variant="h6">
                      Estimated Delivery Time
                    </MDTypography>
                    <MDInput
                      disabled={createUpdateLoading}
                      type="text"
                      placeholder="e.g. Delivery in 3–5 days"
                      fullWidth
                      name="time"
                      value={isData?.time || ""}
                      onChange={handleForm}
                    />
                  </MDBox>
                ) : (
                  <MDBox
                    lineHeight={1}
                    gap={3}
                    width={"100%"}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <MDTypography variant="h6">
                      Service Implementation Time <AstrieskIcon />
                    </MDTypography>
                    <MDInput
                      disabled={createUpdateLoading}
                      required={true}
                      type="text"
                      placeholder="Time In Minutes"
                      fullWidth
                      name="time"
                      value={isData?.time}
                      onChange={handleForm}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            sx={({ palette: { dark, error, info, white } }) => ({
                              "& .MuiTypography-root": {
                                color: !darkMode ? dark.main : white.main, // Customize the text color
                              },
                            })}
                          >
                            Minutes
                          </InputAdornment>
                        ),
                      }}
                    />
                  </MDBox>
                )}

                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"100%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    {!ecom ? "Service Warranty" : "Product Warranty"}{" "}
                    <span style={{ fontSize: "12px" }}>( in Days )</span> <AstrieskIcon />
                  </MDTypography>
                  <MDInput
                    disabled={createUpdateLoading}
                    required={true}
                    type="text"
                    fullWidth
                    name="warranty"
                    onChange={handleForm}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                    }}
                    value={isData?.warranty}
                    placeholder="e.g. 5"
                  />
                </MDBox>

                {ecom ? (
                  <MDBox
                    lineHeight={1}
                    gap={3}
                    width={"100%"}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <MDTypography variant="h6">
                      Return Policy <span style={{ fontSize: "12px" }}>( in Days )</span>
                    </MDTypography>
                    <MDInput
                      disabled={createUpdateLoading}
                      type="text"
                      fullWidth
                      name="returnInDays"
                      onChange={handleForm}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 5);
                      }}
                      value={isData?.returnInDays ?? ""}
                      placeholder="e.g. 7"
                    />
                  </MDBox>
                ) : null}

                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"90%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    Meta Title <AstrieskIcon />
                  </MDTypography>
                  <MDInput
                    disabled={createUpdateLoading}
                    required={true}
                    type="text"
                    placeholder="Meta Title"
                    fullWidth
                    name="metaTitle"
                    value={isData?.metaTitle}
                    onChange={handleForm}
                  />
                </MDBox>
                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"90%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    Meta Description <AstrieskIcon />
                  </MDTypography>
                  <MDInput
                    disabled={createUpdateLoading}
                    required={true}
                    type="text"
                    placeholder="Meta Description"
                    fullWidth
                    name="metaDescription"
                    value={isData?.metaDescription}
                    onChange={handleForm}
                  />
                </MDBox>
                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"100%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    Meta Keywords <AstrieskIcon />
                  </MDTypography>
                  <MultiInput
                    state={isData?.metaKeywords}
                    setState={(e) => handleForm({ target: { name: "metaKeywords", value: e } })}
                    addButtonText="Add New Keywords"
                    addButtonHandler={(e) =>
                      handleForm({ target: { name: "metaKeywords", value: e } })
                    }
                    removeButtonHandler={(e) =>
                      handleForm({ target: { name: "metaKeywords", value: e } })
                    }
                    previousFilledValidate={true}
                    required={true}
                    disabled={createUpdateLoading}
                  />
                </MDBox>

                {ecom ? (
                  <MDBox
                    lineHeight={1}
                    gap={3}
                    width={"100%"}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <MDTypography variant="h6">
                      Product Highlights <span style={{ fontSize: "12px", fontWeight: "normal" }}>(e.g. Smooth finish, Washable, Interior wall paint)</span>
                    </MDTypography>
                    <MultiInput
                      state={isData?.highlights}
                      setState={(e) => handleForm({ target: { name: "highlights", value: e } })}
                      addButtonText="Add New Highlight"
                      addButtonHandler={(e) =>
                        handleForm({ target: { name: "highlights", value: e } })
                      }
                      removeButtonHandler={(e) =>
                        handleForm({ target: { name: "highlights", value: e } })
                      }
                      previousFilledValidate={true}
                      required={false}
                      disabled={createUpdateLoading}
                    />
                  </MDBox>
                ) : null}

                {!ecom ? (
                  <>
                    <MDBox
                      lineHeight={1}
                      gap={3}
                      width={"100%"}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <MDTypography variant="h6">
                        Include <AstrieskIcon />
                      </MDTypography>
                      <MultiInput
                        state={isData?.include}
                        setState={(e) => handleForm({ target: { name: "include", value: e } })}
                        addButtonText="Add New Include"
                        addButtonHandler={(e) =>
                          handleForm({ target: { name: "include", value: e } })
                        }
                        removeButtonHandler={(e) =>
                          handleForm({ target: { name: "include", value: e } })
                        }
                        previousFilledValidate={true}
                        required={true}
                        disabled={createUpdateLoading}
                      />
                    </MDBox>
                    <MDBox
                      lineHeight={1}
                      gap={3}
                      width={"100%"}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }}
                    >
                      <MDTypography variant="h6">
                        Exclude <AstrieskIcon />
                      </MDTypography>
                      <MultiInput
                        state={isData?.exclude}
                        setState={(e) => handleForm({ target: { name: "exclude", value: e } })}
                        addButtonText="Add New Exclude"
                        addButtonHandler={(e) =>
                          handleForm({ target: { name: "exclude", value: e } })
                        }
                        removeButtonHandler={(e) =>
                          handleForm({ target: { name: "exclude", value: e } })
                        }
                        previousFilledValidate={true}
                        required={true}
                        disabled={createUpdateLoading}
                      />
                    </MDBox>
                  </>
                ) : (
                  <MDBox
                    lineHeight={1}
                    gap={3}
                    width={"100%"}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      flexDirection: "column",
                    }}
                  >
                    <MDTypography variant="h6">
                      {!ecom ? "Service Features" : "Product Features"} <AstrieskIcon />
                    </MDTypography>
                    <MultiInput
                      state={isData?.features}
                      setState={(e) => handleForm({ target: { name: "features", value: e } })}
                      addButtonText="Add New Feature"
                      addButtonHandler={(e) =>
                        handleForm({ target: { name: "features", value: e } })
                      }
                      removeButtonHandler={(e) =>
                        handleForm({ target: { name: "features", value: e } })
                      }
                      previousFilledValidate={true}
                      required={true}
                      disabled={createUpdateLoading}
                    />
                  </MDBox>
                )}
              </MDBox>

              {/* <MDBox */}

              <MDBox
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  Select Category&apos;s <AstrieskIcon />
                </MDTypography>
                {/* <ApnaSelect2
                  required={true}
                  data={subCategory}
                  value={isData?.categoryId}
                  origin="Sub Category"
                  onChange={handleForm}
                  name="categoryId"
                  valueKey="_id"
                  nameKey="name"
                  simpleArray={false}
                /> */}

                <InfiniteApnaSelect
                  required={true}
                  multi={false}
                  disabled={createUpdateLoading}
                  fetchApi={`/eCommerce/getAllCategoryByAdmin/${admin}`}
                  fetchApiParams={"&disable=false"}

                  dataFilter={(item) => item.disable === false}
                  value={isData?.categoryId}
                  name="categoryId"
                  onChange={handleForm}
                  origin="Category"
                  valueKey="_id"
                  nameKey="name"
                  isSimpleArray={false}
                  initialLabel={
                    singleProduct?.categoryId?.name ||
                    singleProduct?.category?.name ||
                    singleProduct?.subCategoryId?.name ||
                    (typeof singleProduct?.categoryId === "string" ? "Category Selected" : "")
                  }
                />
              </MDBox>
              <MDBox
                lineHeight={1}
                gap={3}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  Select Tax Slab <AstrieskIcon />
                </MDTypography>
                <ApnaSelect2
                  data={allTax}
                  required={true}
                  value={isData?.taxId}
                  origin="Tax Slab"
                  onChange={handleForm}
                  name="taxId"
                  nameKey={"taxPercent"}
                  valueKey={"_id"}
                  isSimpleArray={false}
                  initialLabel={
                    singleProduct?.taxId?.taxPercent
                      ? `${singleProduct.taxId.taxPercent} %`
                      : typeof singleProduct?.taxId === "string"
                        ? "Tax Selected"
                        : ""
                  }
                />
              </MDBox>
              {ecom ? (
                <MDBox
                  lineHeight={1}
                  gap={3}
                  width={"90%"}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                >
                  <MDTypography variant="h6">
                    Select Brand <AstrieskIcon />
                  </MDTypography>
                  <ApnaSelect2
                    data={allBrands}
                    required={true}
                    value={isData?.brandId}
                    origin="Brand"
                    onChange={handleForm}
                    name="brandId"
                    nameKey={"name"}
                    valueKey={"_id"}
                    isSimpleArray={false}
                    initialLabel={singleProduct?.brandId?.name || ""}
                  />
                </MDBox>
              ) : // <MDBox
                //   lineHeight={1}
                //   gap={3}
                //   width={"90%"}
                //   sx={{
                //     display: "flex",
                //     alignItems: "flex-start",
                //     flexDirection: "column",
                //   }}
                // >
                //   <MDTypography variant="h6">Select City <AstrieskIcon /></MDTypography>
                //   <ApnaSelect2
                //     disabled={createUpdateLoading}
                //     data={city}
                //     required={true}
                //     value={isData?.// cityId}
                //     origin="City"
                //     onChange={
                //       handleForm
                //     }
                //     name="// cityId"
                //     nameKey={'cityName'}
                //     valueKey={'_id'}
                //     isSimpleArray={false}
                //   />
                // </MDBox>
                null}
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1}
                gap={1}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service Thumbnail Image" : "Product Thumbnail Image"} <AstrieskIcon />
                  <MDTypography variant="body1" component="span" fontSize={11}>
                    &nbsp; ( image size - 376 × 200 px )
                  </MDTypography>
                </MDTypography>
                <ImagePicker
                  required={!singleProduct}
                  disabled={createUpdateLoading}
                  // required={true}
                  name="thumbnail"
                  multiple={false}
                  images={isThumbnil}
                  setImages={setIsThumbnil}
                // isImageURLs={isData?.thumbnail}
                />
                

                {isThumbnil === "" && serverThumbnail ? (
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        margin: "0 0.5rem",
                      }}
                    >
                      <img
                        className="Image"
                        style={{ width: "100%", height: "100%" }}
                        src={`${process.env.REACT_APP_URI}${serverThumbnail}`}
                      />
                    </span>
                    {/* <span
                      className="cross"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIsData((prev) => ({
                          ...prev,
                          thumbnail: null,
                        }));
                      }}
                    >
                      <Cancel
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? white?.main : dark.main,
                        })}
                      />
                    </span> */}
                  </div>
                ) : null}
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1}
                gap={1}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service Banners" : "Product Banners"} <AstrieskIcon />
                  <MDTypography variant="body1" component="span" fontSize={11}>
                    &nbsp; ( image size - 540 × 320 px )
                  </MDTypography>
                </MDTypography>
                <ImagePicker
                  required={!singleProduct}
                  disabled={createUpdateLoading}
                  name="images"
                  multiple={true}
                  images={isImages}
                  setImages={setIsImages}
                // isImageURLsImages={isData?.images}
                />
                
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  {!isImages &&
                    serverImages &&
                    serverImages?.length &&
                    serverImages.map((value, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "flex-start" }}>
                        <span
                          style={{
                            display: "inline-block",
                            width: "50px",
                            height: "50px",
                            margin: "0 0.5rem",
                          }}
                        >
                          <img
                            className="Image"
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                            src={`${process.env.REACT_APP_URI}${value?.url}`}
                          />
                        </span>
                        <span
                          className="cross"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // setIsData((prev) => ({
                            //   ...prev,
                            //   images: isData?.images?.filter((obj) => obj !== value),
                            // }));
                            dispatch(
                              updateProductPic({
                                url: ecom
                                  ? `${process.env.REACT_APP_APII}/eCommerce/productUnLinks/${singleProduct?._id}/${admin}`
                                  : `${process.env.REACT_APP_APII}/productUnLinks/${singleProduct?._id}/${admin}`,
                                data: { imageIndex: i + 1 },
                              })
                            ).then((data) => {
                              ;
                              dispatch(
                                handleAlert({
                                  isOpen: true,
                                  type: `${data?.payload?.success ? "success" : "error"}`,
                                  msg: data.payload.message,
                                })
                              );
                              if (data?.payload.success) {
                                const temp = [...serverImages];
                                temp.splice(i, 1);
                                setServerImages(temp);
                              }
                            });
                          }}
                        >
                          <Cancel
                            sx={({ palette: { dark, white, info } }) => ({
                              color: darkMode ? white?.main : dark.main,
                            })}
                          />
                        </span>
                      </div>
                    ))}
                </div>
              </MDBox>
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1}
                gap={1}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  {!ecom ? "Service  Additional Banners" : "Product  Additional Banners"}{" "}
                  <MDTypography variant="body1" component="span" fontSize={11}>
                    &nbsp; ( image size - 540 × 320 px )
                  </MDTypography>
                </MDTypography>
                <ImagePicker
                  required={false}
                  disabled={createUpdateLoading}
                  name="images"
                  multiple={true}
                  images={additionalImages}
                  setImages={setAdditionalImages}
                // isImageURLsImages={isData?.images}
                />
                
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  {!additionalImages &&
                    serverAdditionalImages &&
                    serverAdditionalImages?.length &&
                    serverAdditionalImages.map((value, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "flex-start" }}>
                        <span
                          style={{
                            display: "inline-block",
                            width: "50px",
                            height: "50px",
                            margin: "0 0.5rem",
                          }}
                        >
                          <img
                            className="Image"
                            style={{ width: "100%", height: "100%", objectFit: "contain" }}
                            src={`${process.env.REACT_APP_URI}${value?.url}`}
                          />
                        </span>
                        <span
                          className="cross"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // setIsData((prev) => ({
                            //   ...prev,
                            //   images: isData?.images?.filter((obj) => obj !== value),
                            // }));
                            dispatch(
                              updateProductPic({
                                url: ecom
                                  ? `${process.env.REACT_APP_APII}/eCommerce/productUnLinks/${singleProduct?._id}/${admin}`
                                  : `${process.env.REACT_APP_APII}/productUnLinks/${singleProduct?._id}/${admin}`,
                                data: { additionalIndex: i + 1 },
                              })
                            ).then((data) => {
                              ;
                              dispatch(
                                handleAlert({
                                  isOpen: true,
                                  type: `${data?.payload?.success ? "success" : "error"}`,
                                  msg: data?.payload?.message,
                                })
                              );
                              if (data?.payload?.success) {
                                const temp = [...serverAdditionalImages];
                                temp.splice(i, 1);
                                setServerAdditionalImages(temp);
                              }
                            });
                          }}
                        >
                          <Cancel
                            sx={({ palette: { dark, white, info } }) => ({
                              color: darkMode ? white?.main : dark.main,
                            })}
                          />
                        </span>
                      </div>
                    ))}
                </div>
              </MDBox>
              {/* <MDBox
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  gap: 3,
                }}
              >
                <MDTypography variant="h6">Select Your Video Provider&apos;s</MDTypography>
                <ApnaSelect2
                  // required={true}
                  data={[
                    "YouTube", //"instagram", "faceBook", "other Providers"
                  ]}
                  category={isData?.videoProvider}
                  label="label"
                  setCategory={(e) =>
                    handleForm({
                      target: {
                        name: "videoProvider",
                        value: e,
                      },
                    })
                  }
                  name="videoProvider"
                  simpleArray={true}
                />
                {isData?.videoProvider !== "" && (
                  <MDInput
                    required={true}
                    type="text"
                    placeholder="videoLink"
                    fullWidth
                    name="videoLink"
                    value={isData?.videoLink}
                    onChange={handleForm}
                  />
                )}
              </MDBox> */}

              {/* Specifications Section */}
              <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1}
                gap={1}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">
                  Key Specifications <AstrieskIcon />
                </MDTypography>

                {/* Debug: Log specifications data */}
                {null}

                {isData?.specifications?.map((spec, index) => {
                  // Ensure spec is a valid object with key and value
                  const validSpec = spec && typeof spec === 'object' ? spec : { key: "", value: "" };
                  return (
                    <MDBox
                      key={index}
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        width: "100%",
                        mb: 2,
                      }}
                    >
                      <MDInput
                        disabled={createUpdateLoading}
                        placeholder="Specification Key"
                        value={validSpec?.key || ""}
                        onChange={(e) => {
                          const newSpecs = [...isData.specifications];
                          newSpecs[index] = {
                            ...newSpecs[index],
                            key: e.target.value,
                          };
                          handleForm({
                            target: {
                              name: "specifications",
                              value: newSpecs,
                            },
                          });
                        }}
                        sx={{ flex: 1 }}
                      />
                      <MDInput
                        disabled={createUpdateLoading}
                        placeholder="Specification Value"
                        value={validSpec?.value || ""}
                        onChange={(e) => {
                          const newSpecs = [...isData.specifications];
                          newSpecs[index] = {
                            ...newSpecs[index],
                            value: e.target.value,
                          };
                          handleForm({
                            target: {
                              name: "specifications",
                              value: newSpecs,
                            },
                          });
                        }}
                        sx={{ flex: 1 }}
                      />
                      <MDButton
                        disabled={createUpdateLoading}
                        variant="text"
                        color="error"
                        onClick={() => {
                          const newSpecs = isData.specifications.filter((_, i) => i !== index);
                          handleForm({
                            target: {
                              name: "specifications",
                              value: newSpecs,
                            },
                          });
                        }}
                      >
                        <Delete />
                      </MDButton>
                    </MDBox>
                  );
                })}

                <MDButton
                  disabled={createUpdateLoading}
                  variant="outlined"
                  color="info"
                  onClick={() => {
                    const newSpecs = [...(isData.specifications || []), { key: "", value: "" }];
                    handleForm({
                      target: {
                        name: "specifications",
                        value: newSpecs,
                      },
                    });
                  }}
                  sx={{ mt: 1 }}
                >
                  <Add sx={{ mr: 1 }} />
                  Add Specification
                </MDButton>
              </MDBox>

              {/* <MDBox
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight={1}
                gap={1}
                width={"90%"}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <MDTypography variant="h6">Meta Title</MDTypography>
                <MDInput
                  required={true}
                  type="text"
                  placeholder="metaTitle"
                  fullWidth
                  name="metaTitle"
                  value={isData?.metaTitle}
                  onChange={handleForm}
                />
                <MDTypography variant="h6">Meta Description</MDTypography>
                <MDInput
                  required={true}
                  type="text"
                  placeholder="metaDescription"
                  fullWidth
                  name="metaDescription"
                  value={isData?.metaDescription}
                  onChange={handleForm}
                  multiline
                  rows={6}
                />
                <MDTypography variant="h6">
                  Meta Images{" "}
                  <MDTypography variant="body1" component="span" fontSize={11}>
                    &nbsp; ( image size - 546 × 400 px )
                  </MDTypography>
                </MDTypography>
                <ImagePicker
                  // required={true}
                  name="metaImage"
                  multiple={false}
                  images={isMetaImages}
                  setImages={setIsMetaImages}
                  isImageURLs={isData?.metaImage}
                />
                {isMetaImages === "" && isData?.metaImage && (
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        margin: "0 0.5rem",
                      }}
                    >
                      <img
                        className="Image"
                        style={{ width: "100%", height: "100%" }}
                        src={`${process.env.REACT_APP_URI}/${isData?.metaImage}`}
                      />
                    </span>
                    <span
                      className="cross"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIsData((prev) => ({
                          ...prev,
                          metaImage: null,
                        }));
                      }}
                    >
                      <Cancel
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? white?.main : dark.main,
                        })}
                      />
                    </span>
                  </div>
                )}
              </MDBox> */}

              <MDBox
                sx={{
                  width: "90%",
                  justifyContent: "flex-end",
                  textAlign: "center",
                  display: "flex",
                }}
              >
                {" "}
                <MDButton
                  disabled={createUpdateLoading}
                  color={"info"}
                  verdant={"gradient"}
                  type={"submit"}
                >
                  {createUpdateLoading ? (
                    <CircularProgress size={20} />
                  ) : singleProduct ? (
                    !ecom ? (
                      " Update Service"
                    ) : (
                      " Update Product"
                    )
                  ) : !ecom ? (
                    " Create Service"
                  ) : (
                    " Create Product"
                  )}
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </SkModal>
    </>
  );
};

export default CreateForm;

CreateForm.propTypes = {
  ecom: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.any,
  setIsSwitch: PropTypes.func,
  isSwitch: PropTypes.any,
  productId: PropTypes.string,
  updateProductModal: PropTypes.bool,
  setUpdateProductModal: PropTypes.bool,
};
